import { Helmet } from "react-helmet-async";
import type { SponsorCampaign } from "./campaignTypes";
import { absolutePublicUrl } from "@/app/_utils/constants";

/** Always noindex/nofollow. Not linked from public site navigation. */
export function PartnerResultsHelmet({ campaign }: { campaign: SponsorCampaign }) {
  const title = campaign.shareTitle || campaign.campaignName;
  const description = campaign.campaignSummary;
  const url = absolutePublicUrl(`/partners/${campaign.campaignSlug}`);
  const imageSource = campaign.shareImage || campaign.heroImage;
  const ogImage = /^https?:\/\//i.test(imageSource)
    ? imageSource
    : absolutePublicUrl(imageSource);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="noindex, nofollow" />
      <meta name="googlebot" content="noindex, nofollow" />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={title} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
